import { render, staticRenderFns } from "./FooterSkeletonBox.vue?vue&type=template&id=44acabc9"
import script from "./FooterSkeletonBox.vue?vue&type=script&lang=js"
export * from "./FooterSkeletonBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports